module.exports = __webpack_public_path__ + "static/media/Island_Lake_Vineyards_Bylaws.9e92259e.pdf";